import { type FC } from 'react';
import {
  UserList
} from '@phosphor-icons/react';
import { UiIcon, type UiIconProps } from './UiIcon';

export type UiIconUserListProps = Omit<UiIconProps, 'IconComponent'>;

export const UiIconUserList: FC<UiIconUserListProps> = (props) => {
  return (
    <UiIcon
      IconComponent={UserList}
      {...props}
    />
  );
};
